<div  *ngIf="message === 'Sessões lotadas. Escolha algum usuário da corretora para desconectar da sessão.'">
    <div mat-dialog-title [ngStyle]="{'display':'flex','align-items':'center'}">
        <h3 [ngStyle]="{'margin': '10px 0 10px 6px'}">Número de sessões foi excedido</h3>
        <button mat-icon-button mat-dialog-close [ngStyle]="{'margin': '0 4px 0 auto',  'color': '#727272'}">
            <mat-icon [svgIcon]="'close'"></mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
        <p class=" fontHelvetica16">Escolha algum usuário da corretora para desconectar da sessão:</p>
        <mat-radio-group class="lista check-radio" aria-label="selecao de sessão" (change)="mudaSelecao()" [(ngModel)]="sessaoEscolhida">
            <mat-radio-button name="sessao" class="selection" [value]="sessao" *ngFor="let sessao of usuariosLogados" color="primary">
                <mat-icon class="icon" *ngIf="sessao.dispositivo == 'desktop'" matTooltip="Computador" [svgIcon]="'monitor'"></mat-icon>
                <mat-icon class="icon" *ngIf="sessao.dispositivo == 'mobile'" matTooltip="Celular" [svgIcon]="'cellphone'"></mat-icon>
                <span class="fontDefault">{{sessao.usuario.nome}}</span>
                <!-- <span class="fontDefault">{{sessao.usuario.email}}</span> -->
            </mat-radio-button>
          </mat-radio-group>
    </mat-dialog-content>
    <mat-dialog-actions [ngStyle]="{'display': 'flex','justify-content': 'flex-end',  'align-items': 'center'}">
        <button mat-button mat-dialog-close class="def-w-btn" [disabled]="salvando || !enableButtons">Cancelar</button>
        <button mat-button class="def-b-btn" (click)="refazLogin()" [disabled]="salvando || !enableButtons">Desconectar e Logar
            <mat-icon
            *ngIf="salvando"
            [svgIcon]="'loading'"
            [ngClass]="['loading']"></mat-icon>
        </button>
    </mat-dialog-actions>
</div>

<div *ngIf="message === 'Já existe uma sessão ativa com esse usuário.'">
    <div mat-dialog-title [ngStyle]="{'display':'flex','align-items':'center'}">
        <h3 [ngStyle]="{'margin': '10px 0 10px 6px'}">AVISO</h3>
        <button mat-icon-button mat-dialog-close [ngStyle]="{'margin': '0 4px 0 auto',  'color': '#727272'}">
            <mat-icon [svgIcon]="'close'"></mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
        <div class="container-alert">
            <span class="fontHelvetica16">Caro usuário do Ápice, identificamos que já há uma sessão ativa com este mesmo usuário. Deseja encerra-lá e prosseguir com o login?</span>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions [ngStyle]="{'display': 'flex','justify-content': 'flex-end',  'align-items': 'center'}">
        <button mat-button mat-dialog-close class="def-w-btn" [disabled]="salvando">Cancelar</button>
        <button mat-button  class="def-b-btn" (click)="refazLogin(true)" [disabled]="salvando">Prosseguir
            <mat-icon
            *ngIf="salvando"
            iconPositionEnd
            [svgIcon]="'loading'"
            [ngClass]="['loading']"></mat-icon>
        </button>
    </mat-dialog-actions>
</div>
